<template>
  <div class="faculties">
    <PageHeader
      :item-count="total"
      search-placeholder="Поиск по тренерам и сборным"
      add-item-button-text="Добавить сборную"
      :query-name="'name'"
      :filter-query.sync="filterQuery"
      @addItem="openAside('add-faculty')"
    />
    <div class="faculties__list">
      <FacultyCard
        v-for="faculty in faculties"
        :key="faculty.id"
        class="faculties__list-item"
        :faculty="faculty"
        @edit="onEditClicked(faculty.id)"
        @delete="onDelete(faculty.id)"
      />
    </div>
    <template v-if="loading">
      <FacultyCard class="faculties__list-item" preloader />
      <FacultyCard class="faculties__list-item" preloader />
    </template>
    <NoResults v-if="!loading && !faculties.length" />
    <div ref="scrollTrigger">&nbsp;</div>
    <FacultyAside
      :is-opened="asideOpened"
      :mode="asideMode"
      :options="options"
      :value="selectedFaculty"
      @close="closeAside"
      @add="onAdd"
      @edit="onEdit"
    />
    <DeleteModal :show="showDeleteModal" @confirm="confirmDelete" @cancel="closeDeleteModal">
      Вы действительно хотите удалить сборную?<br />
      Все данные будут потеряны!
    </DeleteModal>
  </div>
</template>

<script>
import PageHeader from '../../../components/PageHeader';
import FacultyCard from '../../../components/FacultyCard';
import FacultyAside from '../../components/FacultyAside';
import NoResults from '../../../components/NoResults';
import DeleteModal from '../../../components/DeleteModal';
import { mapActions, mapMutations, mapState } from 'vuex';
import { debounce } from 'lodash';
import { faculties } from '@/net';

export default {
  name: 'AllFaculties',
  components: {
    PageHeader,
    NoResults,
    FacultyCard,
    FacultyAside,
    DeleteModal
  },
  data: function () {
    return {
      showDeleteModal: false,
      deletableFaculty: undefined,
      asideMode: 'add-faculty',
      asideOpened: false,
      observer: undefined,
      selectedFaculty: undefined,
      getFacultiesDebounced: function () {}
    };
  },
  computed: {
    ...mapState('faculties/admin/faculties', {
      faculties: state => state.faculties,
      total: state => state.meta.faculties.total,
      loading: state => state.meta.faculties.loading,
      finished: state => state.meta.faculties.finished,
      options: state => state.options
    }),
    filterQuery: {
      get() {
        return this.$store.state.faculties.admin.faculties.meta.faculties.search;
      },
      set(value) {
        this.$store.commit('faculties/admin/faculties/setFacultiesSearch', value);
        this.getFacultiesDebounced();
      }
    }
  },
  created() {
    this.clearFaculties();
    this.$store.commit('faculties/admin/faculties/setFacultiesSearch', '');
    this.getFacultiesDebounced = debounce(function () {
      if (!this.loading) {
        this.clearFaculties();
        this.getAllFaculties();
      }
    }, 350);
    this.getOptions();
  },
  mounted() {
    this.observer = new IntersectionObserver(() => {
      if (!this.finished && !this.loading) {
        this.getAllFaculties();
      }
    });
    this.observer.observe(this.$refs.scrollTrigger);
    if (!this.loading) {
      this.getAllFaculties();
    }
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    ...mapActions('faculties/admin/faculties', [
      'getAllFaculties',
      'getOptions',
      'postFaculty',
      'patchFaculty',
      'deleteFaculty'
    ]),
    ...mapMutations('faculties/admin/faculties', ['clearFaculties']),
    openAside(mode) {
      this.asideMode = mode;
      this.asideOpened = true;
    },
    closeAside() {
      this.asideOpened = false;
      this.selectedFaculty = undefined;
    },
    async onEditClicked(id) {
      this.openAside('edit-faculty');
      this.selectedFaculty = this.faculties.find(f => f.id === id);
      this.selectedFaculty = await faculties.getFaculty(id);
    },
    onAdd(faculty) {
      this.postFaculty(faculty);
      this.closeAside();
    },
    onEdit(faculty) {
      this.patchFaculty(faculty);
      this.closeAside();
    },
    onDelete(id) {
      this.deletableFaculty = id;
      this.openDeleteModal();
    },
    openDeleteModal() {
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.deletableFaculty = undefined;
    },
    confirmDelete() {
      this.deleteFaculty(this.deletableFaculty);
      this.closeDeleteModal();
    }
  }
};
</script>

<style lang="scss" scoped>
.faculties {
  &__list {
    display: flex;
    flex-direction: column;

    &-item {
      margin-bottom: 20px;
    }
  }
}
</style>
